import { LabelKey } from '../configs/label-key';

export const nameMap = {
  [LabelKey.Draft]: 'Draft',
  [LabelKey.ReadyForVerification]: 'Ready for Verification',
  [LabelKey.OnVerification]: 'On Verification',
  [LabelKey.OnDigitalization]: 'On Digitalization',
  [LabelKey.ReadyForSale]: 'Ready for Sale',
  [LabelKey.OnSale]: 'On Sale',
  [LabelKey.OnAuction]: 'On Auction',
  [LabelKey.Sold]: 'Sold',

  [LabelKey.Published]: 'Published',
  [LabelKey.Verified]: 'Verified',
  [LabelKey.Pending]: 'Pending',
  [LabelKey.Other]: 'Other',
  [LabelKey.Copy]: 'Copy',
  [LabelKey.Online]: 'Online',
  [LabelKey.Unverified]: 'Unverified',

  [LabelKey.ReadyForMint]: 'Ready for mint',
  [LabelKey.MetadataUploading]: 'Metadata uploading',
  [LabelKey.MetadataUploaded]: 'Metadata uploaded',
  [LabelKey.Minting]: 'Minting',
  [LabelKey.MintingFailed]: 'Minting failed',

  [LabelKey.DigitalOriginalPurchase]: 'DO Purchase',
  [LabelKey.PhysicalOriginalPurchase]: 'PO Purchase',
  [LabelKey.PhysicalAndDigitalOriginalPurchase]: 'P + DO Purchase',

  [LabelKey.Individual]: 'Individual',
  [LabelKey.Group]: 'Group',

  [LabelKey.Active]: 'Active',
  [LabelKey.Canceled]: 'Canceled',
  [LabelKey.Expired]: 'Expired',
  [LabelKey.Finalizing]: 'Finalizing',
} satisfies { [key in LabelKey]: string };
